import PropTypes from 'prop-types';
import React, { Component } from 'react';

if (process.env.NODE_ENV !== 'test') {
  require('./Component.scss');
}

export default class ComponentHeading extends Component {
  static propTypes = {
    handleClick: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.props.handleClick) {
      this.props.handleClick();
    }
  }

  render() {
    return <div className="ComponentHeading">{this.props.children}</div>;
  }
}
